import { paths } from 'src/routes/paths';

export const NODE_ENV  = import.meta.env.VITE_NODE_ENV;
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const API_URL = import.meta.env.VITE_API_URL;
export const USE_LOCAL_APIS = import.meta.env.VITE_API_ENV === 'local';
export const LOCAL_API_URLS: Record<string, string> = {
  auth: import.meta.env.REACT_APP_LOCAL_AUTH_API_URL || '',
  user: import.meta.env.REACT_APP_LOCAL_AUTH_API_URL || '',
  'api/account': import.meta.env.REACT_APP_LOCAL_AUTH_API_URL || '',
  wallet: import.meta.env.REACT_APP_LOCAL_WALLET_API_URL || '',
  points: import.meta.env.REACT_APP_LOCAL_POINTS_ENGINE_API_URL || '',
  'points-engine': import.meta.env.REACT_APP_LOCAL_POINTS_ENGINE_API_URL || '',
  benefits: import.meta.env.REACT_APP_LOCAL_BENEFITS_API_URL || '',
  invoices: import.meta.env.REACT_APP_LOCAL_INVOICES_API_URL || '',
  tiers: import.meta.env.REACT_APP_LOCAL_TIERS_API_URL || '',
  missions: import.meta.env.REACT_APP_LOCAL_MISSIONS_API_URL || '',
  analytics: import.meta.env.REACT_APP_LOCAL_ANALYTICS_API_URL || '',
  achievements: import.meta.env.REACT_APP_LOCAL_ACHIEVEMENTS_API_URL || '',
  partners: import.meta.env.REACT_APP_LOCAL_PARTNERS_API_URL || '',
};
export const ASSETS_API_URL = import.meta.env.VITE_ASSETS_API_URL;
export const VIA_CEP_URL = 'https://viacep.com.br';
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
export const UNAUTHENTICATED_TOKEN = import.meta.env.VITE_UNAUTHENTICATED_TOKEN

export const TEST_AB_EVENT_ID = '68711c5f7dc73bfe9a03c4bf';
export const DEFAULT_EVENT = '-'; // Benfícios Viva Center Norte (PROD)

export const PATH_AFTER_LOGIN = paths.home.root;

export const PATH_TO_REGULATION = 'https://cidadecenternorte.com.br/politica-de-privacidade/';

export const PATH_TO_CONTACT = 'https://api.whatsapp.com/send?phone=5511940759256'
